var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12.1666H9.99341C9.72007 12.1666 9.49341 11.9399 9.49341 11.6666C9.49341 11.3933 9.72007 11.1666 9.99341 11.1666H11.0001C12.7467 11.1666 14.1667 9.74658 14.1667 7.99992C14.1667 6.25325 12.7467 4.83325 11.0001 4.83325H10.0001C9.72674 4.83325 9.50008 4.60659 9.50008 4.33325C9.50008 4.05992 9.72008 3.83325 10.0001 3.83325H11.0001C13.3001 3.83325 15.1667 5.69992 15.1667 7.99992C15.1667 10.2999 13.3001 12.1666 11.0001 12.1666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 12.1666H4.99992C2.69992 12.1666 0.833252 10.2999 0.833252 7.99992C0.833252 5.69992 2.69992 3.83325 4.99992 3.83325H5.99992C6.27325 3.83325 6.49992 4.05992 6.49992 4.33325C6.49992 4.60659 6.27325 4.83325 5.99992 4.83325H4.99992C3.25325 4.83325 1.83325 6.25325 1.83325 7.99992C1.83325 9.74658 3.25325 11.1666 4.99992 11.1666H5.99992C6.27325 11.1666 6.49992 11.3933 6.49992 11.6666C6.49992 11.9399 6.27325 12.1666 5.99992 12.1666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.5H5.33325C5.05992 8.5 4.83325 8.27333 4.83325 8C4.83325 7.72667 5.05992 7.5 5.33325 7.5H10.6666C10.9399 7.5 11.1666 7.72667 11.1666 8C11.1666 8.27333 10.9399 8.5 10.6666 8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.6b3d1823b51104807e33984cfccb75ca.svg";
export { ForwardRef as ReactComponent };